/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileScanHistoryModel } from '../../models/profile-scan-history-model';

export interface ScanBiometricHistoryProfileIdGet$Params {
  profileId: string;
  numberOfMonths?: number;
}

export function scanBiometricHistoryProfileIdGet(http: HttpClient, rootUrl: string, params: ScanBiometricHistoryProfileIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ProfileScanHistoryModel>> {
  const rb = new RequestBuilder(rootUrl, scanBiometricHistoryProfileIdGet.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.query('numberOfMonths', params.numberOfMonths, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ProfileScanHistoryModel>;
    })
  );
}

scanBiometricHistoryProfileIdGet.PATH = '/Scan/BiometricHistory/{profileId}';
